import { useRouteError } from 'react-router';
import * as v from 'valibot';

// oxlint-disable-next-line react-refresh/only-export-components
const ErrorDetails = (props: { error: unknown }) => (
  <div className="mb-2">
    {props.error instanceof Error ? (
      <>
        <pre className="mb-2 rounded-sm bg-gray-100 px-4 py-3 text-sm">{props.error.stack}</pre>
        {props.error.cause && (
          <div>
            <h2 className="mb-2 text-xl font-semibold">Caused by</h2>
            <ErrorDetails error={props.error.cause} />
          </div>
        )}
      </>
    ) : (
      <pre className="mb-2 rounded-sm bg-gray-100 px-4 py-3 text-sm">
        Unknown error: {String(props.error)}
      </pre>
    )}
  </div>
);

const betterError = (error: unknown) => {
  if (!(error instanceof Error)) {
    return new Error(`Unknown error: ${String(error)}`, {
      cause: error,
    });
  }

  if (error.cause) {
    error.cause = betterError(error.cause);
  }

  if (error instanceof v.ValiError) {
    const summary = v.summarize(error.issues);
    const e = new Error(summary, { cause: error });
    e.name = 'UnhandledValiError';
    return e;
  }

  return error;
};

/**
 * Route-level error UI: dev-only stack trace; production rethrows for Sentry
 * (see parent `Sentry.ErrorBoundary` in `root.tsx`).
 */
// oxlint-disable-next-line react-refresh/only-export-components
export function RootRouteErrorBoundary() {
  const rawError = useRouteError();

  const error = betterError(rawError);

  if (import.meta.env.PROD) {
    throw error;
  }

  return (
    <div className="container mx-auto p-4">
      <h1 className="mb-2 text-2xl font-semibold">Application has crashed</h1>

      <ErrorDetails error={error} />

      <p className="mb-4 text-sm text-gray-500 italic">
        This screen is not visible in production, users would see just a blank page with nothing on
        it.
      </p>
    </div>
  );
}
